import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AdminConfigService, AppConfigDTO } from 'src/app/services/admin-config/admin-config.service';
import { environment } from 'src/environments/environment';

interface Section {
  key: string;
  saving: boolean;
  ok: string;
  err: string;
}

@Component({
  selector: 'app-admin-config',
  templateUrl: './admin-config.component.html',
  styleUrls: ['./admin-config.component.scss']
})
export class AdminConfigComponent implements OnInit {

  activeTab = 'login';
  readonly tabs: { id: string; label: string }[] = [
    { id: 'login',           label: 'Inicio de sesión' },
    { id: 'pagos',           label: 'Pagos' },
    { id: 'notificaciones',  label: 'Notificaciones' },
    { id: 'automatizacion',  label: 'Automatización' },
    { id: 'ia',              label: 'Inteligencia Artificial' },
    { id: 'social',          label: 'Redes Sociales' },
    { id: 'whatsappBot',     label: '🤖 Bot WhatsApp' },
    { id: 'googleIndexing',  label: '⚡ Google Indexing API' },
  ];

  cfg: AppConfigDTO = {
    googleClientId: '', linkedinClientId: '', linkedinClientSecret: '',
    linkedinRedirectUri: '', stripeMode: 'test', stripeApiKey: '', stripeTestApiKey: '',
    stripePublicKey: '', stripeTestPublicKey: '',
    stripeWebhookSecret: '', stripeTestWebhookSecret: '',
    stripePriceIdMonthly: '', stripeTestPriceIdMonthly: '', stripePriceIdAnnual: '',
    whatzmeToken: '', whatzmeBaseUrl: '', whatsappAdminNumbers: '',
    deepseekApiKey: '',
    promptNormalizador: '', promptCvOptimizer: '',
    promptGuruMatchExtraccion: '', promptGuruMatchScoring: '',
    googleSet: false, linkedinSet: false, stripeSet: false, whatzmeSet: false, deepseekSet: false,
    smtpHost: '', smtpPort: '', smtpUsername: '', smtpPassword: '', smtpFrom: '', smtpFromName: '', smtpSet: false,
    mesesVacantes: 3,
    horasVacantesRecientes: 48,
    guruMatchMinScore: 80,
    guruMatchMaxResults: 10,
    freebieMatchCount: 3,
    freebieJobHours: 72,
    freeAlertLimit: 2,
    freeGuruMatchLimit: 1,
    freeCvOptimizerLimit: 1,
    freeCvLimit: 1,
    premiumCvLimit: 5,
    freeGuruMatchVisible: 3,
    freeAlertVisible: 2,
    premiumAlertLimitDay: 1,
    premiumGuruMatchLimitDay: 1,
    premiumCvOptimizerLimitDay: 1,
    freeAlertEmail: true,
    freeAlertWhatsapp: false,
    premiumAlertEmail: true,
    premiumAlertWhatsapp: true,
    jwtExpirationHours: 8,
    scraperHabilitado: true,
    alertasHabilitadas: true,
    openaiApiKey: '', openaiSet: false,
    wordpressBaseUrl: '', wordpressApiBaseUrl: '', wordpressUsername: '', wordpressAppPassword: '', wordpressSet: false, wordpressEnabled: false, wordpressReady: false,
    facebookPageId: '', facebookPageAccessToken: '', facebookSet: false, facebookEnabled: false, facebookReady: false,
    instagramBusinessAccountId: '', instagramSet: false, instagramEnabled: false, instagramReady: false,
    linkedinOrganizationId: '', linkedinOrgAccessToken: '', linkedinOrgSet: false, linkedinEnabled: false, linkedinReady: false,
    promptSocialCopy: '',
    autoPublishSocialEnabled: false,
    // Bot WhatsApp entrante
    whatsappBotEnabled: true,
    whatsappWebhookSecret: '',
    promptWhatsappIntent: '',
    promptWhatsappReply: '',
    whatsappTriggerKeyword: '',
    whatsappSessionTimeoutMinutes: 15,
    // Google Indexing API
    googleIndexingEnabled: true,
    googleIndexingServiceAccountJson: '',
    googleIndexingSet: false,
  };

  sections: Record<string, Section> = {
    google:         { key: 'google',         saving: false, ok: '', err: '' },
    linkedin:       { key: 'linkedin',       saving: false, ok: '', err: '' },
    stripe:         { key: 'stripe',         saving: false, ok: '', err: '' },
    whatzme:        { key: 'whatzme',        saving: false, ok: '', err: '' },
    ia:             { key: 'ia',             saving: false, ok: '', err: '' },
    prompts:        { key: 'prompts',        saving: false, ok: '', err: '' },
    smtp:           { key: 'smtp',           saving: false, ok: '', err: '' },
    automaticos:    { key: 'automaticos',    saving: false, ok: '', err: '' },
    redesSociales:  { key: 'redesSociales',  saving: false, ok: '', err: '' },
    whatsappBot:    { key: 'whatsappBot',    saving: false, ok: '', err: '' },
    googleIndexing: { key: 'googleIndexing', saving: false, ok: '', err: '' },
  };

  show: Record<string, boolean> = {};
  loadingTokens = false;
  revealedTokens: Record<string, string> | null = null;

  smtpTestEmail = '';
  smtpTesting = false; smtpTestOk = ''; smtpTestErr = '';
  wpTesting = false; wpTestOk = ''; wpTestErr = '';
  fbTesting = false; fbTestOk = ''; fbTestErr = '';
  igTesting = false; igTestOk = ''; igTestErr = '';
  liTesting = false; liTestOk = ''; liTestErr = '';
  oaTesting = false; oaTestOk = ''; oaTestErr = '';
  dsTesting = false; dsTestOk = ''; dsTestErr = '';
  waBotResetting = false;
  giTesting = false; giTestOk = ''; giTestErr = '';
  giBatching = false; giBatchOk = ''; giBatchErr = '';

  alertDiag: any = null;
  diagCargando = false;

  objectKeys = Object.keys;
  objectEntries = Object.entries;

  constructor(private svc: AdminConfigService, private router: Router, private authService: AuthService, private http: HttpClient) {}

  ngOnInit(): void {
    this.svc.get().subscribe({
      next: res => { if (res?.data) this.cfg = { ...this.cfg, ...res.data }; },
      error: ()  => {}
    });
  }

  guardar(seccion: string): void {
    const s = this.sections[seccion];
    if (seccion === 'prompts' && !this.cfg.promptNormalizador?.trim()) {
      s.ok = '';
      s.err = 'El prompt normalizador es obligatorio porque MongoDB es la única fuente de configuración.';
      return;
    }
    s.saving = true; s.ok = ''; s.err = '';

    let payload: Partial<AppConfigDTO>;
    if (seccion === 'google') {
      payload = { googleClientId: this.cfg.googleClientId };
    } else if (seccion === 'linkedin') {
      payload = {
        linkedinClientId:     this.cfg.linkedinClientId,
        linkedinClientSecret: this.cfg.linkedinClientSecret,
        linkedinRedirectUri:  this.cfg.linkedinRedirectUri,
      };
    } else if (seccion === 'stripe') {
      payload = {
        stripeMode:               this.cfg.stripeMode,
        stripeApiKey:             this.cfg.stripeApiKey,
        stripeTestApiKey:         this.cfg.stripeTestApiKey,
        stripePublicKey:          this.cfg.stripePublicKey,
        stripeTestPublicKey:      this.cfg.stripeTestPublicKey,
        stripeWebhookSecret:      this.cfg.stripeWebhookSecret,
        stripeTestWebhookSecret:  this.cfg.stripeTestWebhookSecret,
        stripePriceIdMonthly:     this.cfg.stripePriceIdMonthly,
        stripeTestPriceIdMonthly: this.cfg.stripeTestPriceIdMonthly,
        stripePriceIdAnnual:      this.cfg.stripePriceIdAnnual,
      };
    } else if (seccion === 'whatzme') {
      payload = {
        whatzmeToken:   this.cfg.whatzmeToken,
        whatzmeBaseUrl: this.cfg.whatzmeBaseUrl,
        whatsappAdminNumbers: this.cfg.whatsappAdminNumbers,
      };
    } else if (seccion === 'ia') {
      payload = { deepseekApiKey: this.cfg.deepseekApiKey, mesesVacantes: this.cfg.mesesVacantes,
        horasVacantesRecientes: this.cfg.horasVacantesRecientes,
        guruMatchMinScore: this.cfg.guruMatchMinScore, guruMatchMaxResults: this.cfg.guruMatchMaxResults,
        freeAlertLimit: this.cfg.freeAlertLimit, freeGuruMatchLimit: this.cfg.freeGuruMatchLimit,
        freeCvOptimizerLimit: this.cfg.freeCvOptimizerLimit, freeCvLimit: this.cfg.freeCvLimit,
        premiumCvLimit: this.cfg.premiumCvLimit, freeGuruMatchVisible: this.cfg.freeGuruMatchVisible,
        freeAlertVisible: this.cfg.freeAlertVisible,
        premiumAlertLimitDay: this.cfg.premiumAlertLimitDay,
        premiumGuruMatchLimitDay: this.cfg.premiumGuruMatchLimitDay,
        premiumCvOptimizerLimitDay: this.cfg.premiumCvOptimizerLimitDay,
        freeAlertEmail: this.cfg.freeAlertEmail,
        freeAlertWhatsapp: this.cfg.freeAlertWhatsapp,
        premiumAlertEmail: this.cfg.premiumAlertEmail,
        premiumAlertWhatsapp: String(this.cfg.premiumAlertWhatsapp) as any,
        jwtExpirationHours: this.cfg.jwtExpirationHours } as any;
    } else if (seccion === 'smtp') {
      payload = {
        smtpHost: this.cfg.smtpHost,
        smtpPort: this.cfg.smtpPort,
        smtpUsername: this.cfg.smtpUsername,
        smtpPassword: this.cfg.smtpPassword,
        smtpFrom: this.cfg.smtpFrom,
        smtpFromName: this.cfg.smtpFromName,
      };
    } else if (seccion === 'automaticos') {
      payload = {
        scraperHabilitado:  String(this.cfg.scraperHabilitado)  as any,
        alertasHabilitadas: String(this.cfg.alertasHabilitadas) as any,
        freebieMatchCount: this.cfg.freebieMatchCount,
        freebieJobHours: this.cfg.freebieJobHours,
      };
    } else if (seccion === 'redesSociales') {
      payload = {
        openaiApiKey: this.cfg.openaiApiKey,
        wordpressBaseUrl: this.cfg.wordpressBaseUrl,
        wordpressApiBaseUrl: this.cfg.wordpressApiBaseUrl,
        wordpressUsername: this.cfg.wordpressUsername,
        wordpressAppPassword: this.cfg.wordpressAppPassword,
        wordpressEnabled: String(this.cfg.wordpressEnabled) as any,
        facebookPageId: this.cfg.facebookPageId,
        facebookPageAccessToken: this.cfg.facebookPageAccessToken,
        facebookEnabled: String(this.cfg.facebookEnabled) as any,
        instagramBusinessAccountId: this.cfg.instagramBusinessAccountId,
        instagramEnabled: String(this.cfg.instagramEnabled) as any,
        linkedinOrganizationId: this.cfg.linkedinOrganizationId,
        linkedinOrgAccessToken: this.cfg.linkedinOrgAccessToken,
        linkedinEnabled: String(this.cfg.linkedinEnabled) as any,
        autoPublishSocialEnabled: String(this.cfg.autoPublishSocialEnabled) as any,
      };
    } else if (seccion === 'whatsappBot') {
      payload = {
        whatsappBotEnabled:    String(this.cfg.whatsappBotEnabled) as any,
        whatsappWebhookSecret: this.cfg.whatsappWebhookSecret,
        promptWhatsappIntent:  this.cfg.promptWhatsappIntent,
        promptWhatsappReply:   this.cfg.promptWhatsappReply,
        whatsappTriggerKeyword: this.cfg.whatsappTriggerKeyword,
        whatsappSessionTimeoutMinutes: String(Math.max(0, this.cfg.whatsappSessionTimeoutMinutes || 0)) as any,
      };
    } else if (seccion === 'googleIndexing') {
      payload = {
        googleIndexingEnabled:            String(this.cfg.googleIndexingEnabled) as any,
        googleIndexingServiceAccountJson: this.cfg.googleIndexingServiceAccountJson,
      };
    } else {
      payload = {
        promptNormalizador: this.cfg.promptNormalizador,
        promptCvOptimizer:  this.cfg.promptCvOptimizer,
        promptSocialCopy:   this.cfg.promptSocialCopy,
        promptGuruMatchExtraccion: this.cfg.promptGuruMatchExtraccion,
        promptGuruMatchScoring:    this.cfg.promptGuruMatchScoring,
      };
    }

    this.svc.save(payload).subscribe({
      next: () => {
        s.ok = 'Guardado correctamente.';
        s.saving = false;
        setTimeout(() => s.ok = '', 3500);
        this.recargarEstado();
      },
      error: err => {
        s.err = err?.error?.message ?? err?.error?.messageError ?? 'Error al guardar.';
        s.saving = false;
        setTimeout(() => s.err = '', 4000);
      }
    });
  }

  toggleShow(field: string): void {
    if (!this.show[field]) {
      this.ensureTokens(() => {
        const val = this.revealedTokens?.[field];
        if (val) (this.cfg as any)[field] = val;
        this.show[field] = true;
      });
    } else {
      this.show[field] = false;
    }
  }

  resetPrompt(field: 'promptCvOptimizer' | 'promptSocialCopy' | 'promptGuruMatchExtraccion' | 'promptGuruMatchScoring' | 'promptWhatsappIntent' | 'promptWhatsappReply'): void {
    this.cfg[field] = '';
  }

  get webhookUrl(): string {
    const secret = this.cfg.whatsappWebhookSecret || '(secreto-pendiente)';
    return `${environment.baseApi}/publico/whatsapp/webhook/${secret}`;
  }

  copyWebhookUrl(): void {
    navigator.clipboard.writeText(this.webhookUrl).then(() => {
      this.sections['whatsappBot'].ok = 'URL copiada al portapapeles';
      setTimeout(() => this.sections['whatsappBot'].ok = '', 3000);
    });
  }

  restaurarPromptsWhatsapp(): void {
    if (!confirm('¿Restaurar los prompts del bot al texto canónico? Esto sobreescribirá los prompts actuales en MongoDB.')) return;
    this.waBotResetting = true;
    this.svc.resetWhatsappPrompts().subscribe({
      next: () => {
        this.waBotResetting = false;
        this.sections['whatsappBot'].ok = 'Prompts restaurados en MongoDB. Recargando...';
        setTimeout(() => {
          this.sections['whatsappBot'].ok = '';
          this.recargarEstado();
        }, 1500);
      },
      error: err => {
        this.waBotResetting = false;
        this.sections['whatsappBot'].err = err?.error?.message ?? err?.error?.messageError ?? 'Error al restaurar prompts.';
        setTimeout(() => this.sections['whatsappBot'].err = '', 5000);
      }
    });
  }

  testGoogleIndexing(): void {
    this.giTesting = true; this.giTestOk = ''; this.giTestErr = '';
    this.svc.testGoogleIndexing().subscribe({
      next: (res: any) => {
        this.giTesting = false;
        this.giTestOk = res?.data ?? res?.message ?? 'Prueba exitosa.';
      },
      error: (err: any) => {
        this.giTesting = false;
        this.giTestErr = err?.error?.message ?? err?.error?.messageError ?? 'Error al probar Google Indexing API.';
      }
    });
  }

  indexAllVacancies(): void {
    if (!confirm('¿Deseas enviar todas las vacantes activas a Google Indexing API ahora?')) return;
    this.giBatching = true; this.giBatchOk = ''; this.giBatchErr = '';
    this.svc.indexAllVacancies().subscribe({
      next: (res: any) => {
        this.giBatching = false;
        this.giBatchOk = res?.data ?? res?.message ?? 'Indexación masiva iniciada en segundo plano.';
      },
      error: (err: any) => {
        this.giBatching = false;
        this.giBatchErr = err?.error?.message ?? err?.error?.messageError ?? 'Error al iniciar indexación masiva.';
      }
    });
  }

  private ensureTokens(cb: () => void): void {
    if (this.revealedTokens !== null) { cb(); return; }
    this.loadingTokens = true;
    this.svc.getTokens().subscribe({
      next: res => { this.revealedTokens = res?.data ?? res; this.loadingTokens = false; cb(); },
      error: () => { this.loadingTokens = false; }
    });
  }

  private recargarEstado(): void {
    this.svc.get().subscribe({ next: res => { if (res?.data) this.cfg = { ...this.cfg, ...res.data }; } });
  }

  testSmtp(): void {
    if (!this.smtpTestEmail) { this.smtpTestErr = 'Ingresa un correo destino.'; return; }
    this.smtpTesting = true; this.smtpTestOk = ''; this.smtpTestErr = '';
    this.svc.testSmtp(this.smtpTestEmail).subscribe({
      next: () => { this.smtpTestOk = 'Correo enviado correctamente.'; this.smtpTesting = false; setTimeout(() => this.smtpTestOk = '', 4000); },
      error: err => { this.smtpTestErr = err?.error?.message ?? err?.error?.messageError ?? 'Error al enviar.'; this.smtpTesting = false; setTimeout(() => this.smtpTestErr = '', 5000); }
    });
  }

  testWordpress(): void {
    this.wpTesting = true; this.wpTestOk = ''; this.wpTestErr = '';
    this.svc.testWordpress().subscribe({
      next: (res: any) => { this.wpTestOk = res?.data?.message ?? res?.message ?? 'Conexión exitosa con WordPress.'; this.wpTesting = false; setTimeout(() => this.wpTestOk = '', 5000); },
      error: err => { this.wpTestErr = err?.error?.message ?? err?.error?.messageError ?? 'Error al conectar con WordPress.'; this.wpTesting = false; setTimeout(() => this.wpTestErr = '', 6000); }
    });
  }

  testOpenai(): void {
    this.oaTesting = true; this.oaTestOk = ''; this.oaTestErr = '';
    this.svc.testOpenai().subscribe({
      next: (res: any) => { this.oaTestOk = res?.data?.message ?? res?.message ?? 'Conexión exitosa con OpenAI.'; this.oaTesting = false; setTimeout(() => this.oaTestOk = '', 5000); },
      error: err => { this.oaTestErr = err?.error?.message ?? err?.error?.messageError ?? 'Error al conectar con OpenAI.'; this.oaTesting = false; setTimeout(() => this.oaTestErr = '', 8000); }
    });
  }

  testDeepseek(): void {
    this.dsTesting = true; this.dsTestOk = ''; this.dsTestErr = '';
    this.svc.testDeepseek().subscribe({
      next: (res: any) => { this.dsTestOk = res?.data?.message ?? res?.message ?? 'Conexión exitosa con DeepSeek.'; this.dsTesting = false; setTimeout(() => this.dsTestOk = '', 5000); },
      error: err => { this.dsTestErr = err?.error?.message ?? err?.error?.messageError ?? 'Error al conectar con DeepSeek.'; this.dsTesting = false; setTimeout(() => this.dsTestErr = '', 8000); }
    });
  }

  testFacebook(): void {
    this.fbTesting = true; this.fbTestOk = ''; this.fbTestErr = '';
    this.svc.testFacebook().subscribe({
      next: (res: any) => { this.fbTestOk = res?.data?.message ?? res?.message ?? 'Conexión exitosa con Facebook.'; this.fbTesting = false; setTimeout(() => this.fbTestOk = '', 5000); },
      error: err => { this.fbTestErr = err?.error?.message ?? err?.error?.messageError ?? 'Error al conectar con Facebook.'; this.fbTesting = false; setTimeout(() => this.fbTestErr = '', 6000); }
    });
  }

  testInstagram(): void {
    this.igTesting = true; this.igTestOk = ''; this.igTestErr = '';
    this.svc.testInstagram().subscribe({
      next: (res: any) => {
        this.igTestOk = res?.data?.message ?? res?.message ?? 'Conexión exitosa con Instagram.';
        this.igTesting = false;
        setTimeout(() => this.igTestOk = '', 5000);
        this.recargarEstado(); // puede haber autodetectado instagramBusinessAccountId
      },
      error: err => { this.igTestErr = err?.error?.message ?? err?.error?.messageError ?? 'Error al conectar con Instagram.'; this.igTesting = false; setTimeout(() => this.igTestErr = '', 6000); }
    });
  }

  testLinkedin(): void {
    this.liTesting = true; this.liTestOk = ''; this.liTestErr = '';
    this.svc.testLinkedin().subscribe({
      next: (res: any) => { this.liTestOk = res?.data?.message ?? res?.message ?? 'Conexión exitosa con LinkedIn.'; this.liTesting = false; setTimeout(() => this.liTestOk = '', 5000); },
      error: err => { this.liTestErr = err?.error?.message ?? err?.error?.messageError ?? 'Error al conectar con LinkedIn — verifica si tu app ya tiene aprobado el acceso a la Community Management API.'; this.liTesting = false; setTimeout(() => this.liTestErr = '', 8000); }
    });
  }

  cargarDiagnosticoAlertas(): void {
    this.diagCargando = true;
    this.http.get(`${environment.baseApi}/privado/alertas/admin/diagnostico`).subscribe({
      next: (res: any) => { this.alertDiag = res?.data ?? res; this.diagCargando = false; },
      error: ()        => { this.diagCargando = false; }
    });
  }

  cerrarSesion(): void {
    this.router.navigate(['/acceder']);
  }
}
